import * as React from 'react';

export type LearnScope = 'learn' | 'simulate';

export const LearnScopeContext = React.createContext<LearnScope>('learn');

export const useLearnScope = (): LearnScope => React.useContext(LearnScopeContext);
